import {
  ListEntryTypeRequest,
  EntryTypeServiceClient,
} from '../proto/admpb/entrytype_grpc_web_pb';
import { auth } from '../lib/auth/Auth';

const service = new EntryTypeServiceClient(
  window.env.GRPC_ENDPOINT,
  {},
  { ...auth }
);

export async function listEntryType(param) {
  return new Promise((resolve, reject) => {
    let req = new ListEntryTypeRequest();
    req.setEntryType(param.entryType);
    req.setCorrespondent(param.correspondent);
    req.setAccountNo(param.accountNo);
    req.setScreenType(param.screenType);

    service.listEntryType(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
